// extracted by mini-css-extract-plugin
export default {"wrapper":"StudentWebinarFooter_wrapper__I1buz"};